/**
 * Assistance partenaire.
 */
import { MessageSquare, Phone } from 'lucide-react';
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { DashboardLayout } from '@/components/dashboard/dashboard-layout';

export function PartnerAssistancePage() {
  return (
    <DashboardLayout variant="partenaire" title="Assistance">
      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader className="flex flex-row items-start gap-3">
            <Phone className="h-5 w-5 text-bcl-blue" />
            <div>
              <CardTitle className="text-base">Référent partenaires BCL</CardTitle>
              <CardDescription>+33 1 00 00 00 00 (lun-ven 9h-18h).</CardDescription>
            </div>
          </CardHeader>
        </Card>
        <Card>
          <CardHeader className="flex flex-row items-start gap-3">
            <MessageSquare className="h-5 w-5 text-bcl-blue" />
            <div>
              <CardTitle className="text-base">Conformité</CardTitle>
              <CardDescription>
                Gardez vos pièces (KBIS, URSSAF, assurance RC) à jour pour rester
                éligible aux interventions.
              </CardDescription>
            </div>
          </CardHeader>
        </Card>
      </div>
    </DashboardLayout>
  );
}
